import {
  canEditAccountConfiguration,
  canEditGlobalConfiguration,
} from "@common/utils/user";
import { AuthenticatedUser } from "@services/user/types";

export const canEditConfiguration = (
  user?: AuthenticatedUser,
  locationId?: string,
  accountId?: string
) =>
  accountId ?? locationId
    ? canEditAccountConfiguration(user)
    : canEditGlobalConfiguration(user);
